import { Component, Input, OnChanges } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import {
  QaiInfoBlockComponent,
  QaiLabelComponent,
  QaiResultsTabComponent,
  QaiSectionHeaderComponent,
  type SectionHeaderIndicator,
} from '@qai/ui';
import { IObjectiveConversational } from 'src/app/interfaces/iobjective-conversational';
import { getTabScoreKind } from 'src/app/utils/score-kind.util';
import { LocaleService } from 'src/app/services/locale.service';

interface ObjectiveViewModel {
  title: string;
  feedback: string;
  scoreIndicator: SectionHeaderIndicator;
  suggestItems: string[];
  whyItems: string[];
}

@Component({
  selector: 'app-result-methodology',
  standalone: true,
  imports: [
    TranslocoModule,
    QaiResultsTabComponent,
    QaiSectionHeaderComponent,
    QaiLabelComponent,
    QaiInfoBlockComponent,
  ],
  templateUrl: './result-methodology.component.html',
  styleUrls: ['./result-methodology.component.scss'],
})
export class ResultMethodologyComponent implements OnChanges {
  @Input() objectives: IObjectiveConversational[] = [];
  @Input() scoreCriteria: number = 0;

  tabScore = '';
  tabScoreKind: 'success' | 'error' | 'warning' = 'success';
  viewObjectives: ObjectiveViewModel[] = [];

  constructor(private localeService: LocaleService) {}

  ngOnChanges(): void {
    const total = this.objectives.reduce((sum, o) => sum + o.score, 0);
    const avg = this.objectives.length ? total / this.objectives.length : 0;
    this.tabScore = this.objectives.length
      ? this.localeService.formatNumber(avg, 1)
      : '';
    this.tabScoreKind = getTabScoreKind(avg, this.scoreCriteria);
    this.viewObjectives = this.objectives.map((o) => ({
      title: o.title,
      feedback: o.feedback,
      scoreIndicator: this.buildScoreIndicator(o.score),
      suggestItems: o.examples.map((e) => e.improved).filter(Boolean),
      whyItems: o.examples.map((e) => e.effect).filter(Boolean),
    }));
  }

  private buildScoreIndicator(score: number): SectionHeaderIndicator {
    const kind = score >= 4 ? 'success' : score >= 3 ? 'warning' : 'error';
    return { type: 'text', kind, label: `${score}/5`, size: 'xlarge' };
  }
}
